import { useState } from "react";
import type { FilmReview } from "@/types/film";

interface ReviewPanelProps {
  reviews: FilmReview[];
}

export default function ReviewPanel({ reviews }: ReviewPanelProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const visible = reviews.slice(0, 3);

  return (
    <section id="reviews" className="mt-6 scroll-mt-24 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
          <span className="h-4 w-[3px] rounded-full bg-accent-500" />
          影评精选
        </h2>
        <span className="text-xs text-foreground-400">{reviews.length} 篇收录</span>
      </div>

      {visible.length === 0 ? (
        <div className="mt-5 flex flex-col items-center justify-center rounded-md border border-dashed border-background-300 bg-background-100 px-4 py-12 text-center">
          <i className="ri-chat-off-line text-2xl text-foreground-400" />
          <p className="mt-3 text-sm text-foreground-600">暂无影评</p>
          <p className="mt-1 text-xs text-foreground-400">这部作品的解析正在整理中，欢迎通过联系页面推荐给我们。</p>
        </div>
      ) : (
        <div className="mt-5 space-y-4">
          {visible.map((review, index) => {
            const expanded = openIndex === index;
            return (
              <article key={review.title} className="rounded-md border border-background-200 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                  <span className="rounded-sm bg-accent-100 px-2 py-0.5 text-accent-800">影评</span>
                  <span>{review.author}</span>
                  <span>·</span>
                  <span>{review.date}</span>
                </div>
                <h3 className="mt-2.5 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {review.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {expanded ? review.content.join(" ") : review.excerpt}
                </p>

                {expanded && (
                  <div className="mt-3 space-y-3 rounded-md bg-background-100 p-4 text-sm leading-[1.9] text-foreground-700">
                    {review.content.map((paragraph, paragraphIndex) => (
                      <p key={paragraphIndex}>{paragraph}</p>
                    ))}
                  </div>
                )}

                <div className="mt-3 flex items-center justify-between">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(expanded ? null : index)}
                    className="flex items-center gap-1 whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
                  >
                    {expanded ? "收起影评" : "展开影评"}
                    <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
                  </button>
                  <span className="text-[11px] text-foreground-400">演示内容 · 观点仅代表作者</span>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}